import { formatPercent } from 'utils';
import moment, { Moment } from 'moment';

export const formatValue = (value: number | null) => {
  if (value === null) return '-';
  return formatPercent(value * 100, true);
};

export const getDate = (
  date: string | null,
  value: number | null = 0,
  period: any = 'years'
) => {
  if (!date) {
    return null;
  }

  return moment(date).subtract(value || 0, period);
};

export const formatDate = (date: Moment) => {
  return moment(date).format('DD/MM/YYYY');
};
